import { useEffect } from "react";

import { useAppDispatch } from "@/hooks/redux";
import { listenSettings } from "@/store/reducers/settings/asyncActionCreators";
import {
  activeExaminationListener,
  listenAllExaminationData,
  listenCurrentExaminationData,
  listenExaminationData,
  listenM15,
  listenPlcError,
  newCorrectionListener,
  unrecordedExaminationListener,
} from "@/store/reducers/currentData/asyncActionCreators";
import { standConnectionListener } from "@/store/reducers/serverConnection/asyncActionCreators";

const useListeners = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(listenSettings());
  }, [dispatch]);

  useEffect(() => {
    dispatch(activeExaminationListener());
    dispatch(listenM15());
    dispatch(listenPlcError());
    dispatch(listenAllExaminationData());
    dispatch(newCorrectionListener());
    dispatch(unrecordedExaminationListener());
    dispatch(listenExaminationData());
    dispatch(listenCurrentExaminationData());
    dispatch(listenSettings());
    dispatch(standConnectionListener());
  }, [dispatch]);
};

export default useListeners;
